/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyMenuItemSupplyModel as DigiworkMaitreDPosDtoMenuCompanyMenuItemSupplyModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/company-menu-item-supply-model';

export interface UpdateMenuItem$Params {
      body?: {
'Id'?: string;
'Name'?: string;
'Description'?: string;
'CompanyMenuCategoryId'?: string;
'LanguageId'?: number;
'Price'?: number;
'MenuItemTypeId'?: number;
'ImageFile'?: Blob;
'Supplies'?: Array<DigiworkMaitreDPosDtoMenuCompanyMenuItemSupplyModel>;
'TaxRateId'?: string;
'SubVenueIds'?: Array<string>;
}
}

export function updateMenuItem(http: HttpClient, rootUrl: string, params?: UpdateMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateMenuItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateMenuItem.PATH = '/api/gmn/Menu/updatemenuitem';
